import { CurrencyPipe } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Money } from 'src/business/services/client.generated';
import { PricePipeOption } from './models/price-pipe-option.model';
import { Price } from './models/price-transformers';
import { LANGUAGE } from '../misselaineous/boot.tokens';
import { Guard } from '../misselaineous/guards';




@Pipe({
    name: 'price',
    standalone: true,
})
export class PricePipe implements PipeTransform {
    private _pipe: CurrencyPipe;

    constructor(
        @Inject(LANGUAGE)
        private __locale: string,
    ) {
        this._pipe = new CurrencyPipe(this.__locale, 'DKK');
    }

    transform(price: Money, option?: PricePipeOption): string {
        let displayPrice = '';
        if (Guard.is.nullOrEmpty(price))
            return;

        // else if (Array.isArray(this.priceFn) && this.priceFn.length > 0)
        //     displayPrice = this.priceFn.reduce((priceAsString: string, transformer: Function) => transformer(priceAsString, price, option), displayPrice);
        // else if (this.priceFn != null)
        //     displayPrice = (this.priceFn as Price.PriceTransformer)(displayPrice, price, option);
        // else if (this._pipe != null && price.amount % 1 !== 0 && option != null && option['mayShowComma'])
        //     displayPrice = this._pipe.transform(price.amount, price.currency,'symbol', '1.2-2', this.__locale);
        // else if (this._pipe != null)
        //     displayPrice = this._pipe.transform(price.amount, price.currency,'symbol', '1.0', this.__locale);
        return Price.simple(displayPrice, price, option);
    }
}
